import { api } from "../api/Middleware";
import { USERS_URL, BASE_URL } from "../api/Urls";
import { ERROR_MESSAGES } from "../helpers/ErrorMessages";

export const GetOne = async (id, setData, setValue, setIsLoading) => {
  try {
    let response = await api.get(USERS_URL + id + "/get_all_info/");
    if (response.status === 200) {
      setValue("birthday", response.data.user.birthday);
      setValue("phone", response.data.user.phone);
      setData(response.data);
    }
  } catch (error) {
    //TODO: TRATAR ERRORS 401 NO MIDDLEWARE
    /*  if(error.status !== 401){
             
             
         }  */
  }
  setIsLoading(false);
};

export const GetAll = async (setUsers, setErrors, setIsLoading) => {
  try {
    let response = await api.get(USERS_URL + "get_all/");
    if (response.status === 200) setUsers(response.data);
  } catch (error) {
    setErrors({ title: "Oops!", message: ERROR_MESSAGES.categories.get });
  }

  setIsLoading(false);
};

export const Create = async (data, setProduct, setNotify, setError) => {
  try {
    let response = await api.post(USERS_URL, data);
    if (response.status === 200) {
      setProduct(response.data);
      setNotify({
        title: "Sucesso!",
        message: "Produto cadastrado com sucesso!",
        type: "success",
        visible: true,
      });
      window.history.pushState(
        null,
        "",
        window.location.href + response.data.id
      );
    }
  } catch (error) {
    if (error.response.status === 400) {
      setError("name", {
        message: error.response.data,
        type: "custom",
      });
    } else if (error.response.status === 401) {
      window.location.href = BASE_URL;
    } else {
      setNotify({
        title: "Oops!",
        message: ERROR_MESSAGES.categories.update,
        type: "error",
        visible: true,
      });
    }
    //if(error.status !== 401) throw error.response;
  }
};

export const Update = async (id, data, setData, setNotify) => {
  console.log(data);
  try {
    let response = await api.put(USERS_URL + id + "/", data);
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Cliente atualizado com sucesso!",
        type: "success",
        visible: true,
      });
    }
  } catch (error) {
    //if(error.status !== 401) throw error.response;
    setNotify({
      title: "Oops!",
      message: ERROR_MESSAGES.products.update,
      type: "error",
      visible: true,
    });
  }
};

export const ChangeStatus = async (data, setNotify, setProgress) => {
  setProgress(true);
  try {
    let response = await api.put(USERS_URL + data.id + "/", {
      is_active: parseInt(data.status),
    });
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Status atualizado com sucesso!",
        type: "success",
        visible: true,
      });
      setProgress(false);
      return true;
    }
  } catch (error) {
    setNotify({
      title: "Oops!",
      message: ERROR_MESSAGES.orders.status,
      type: "error",
      visible: true,
    });
    setProgress(false);
    return false;
  }
};

export const Delete = async (id, setNotify, setProgress) => {
  setProgress(true);

  try {
    let ids = [id];

    let response = await api.delete(USERS_URL + "delete_multiple/", {
      data: { ids: ids },
    });
    if (response.status === 200) {
      setNotify({
        title: "Sucesso!",
        message: "Operação realizada com sucesso!",
        type: "success",
        visible: true,
      });
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    }
  } catch (error) {
    //if(error.status !== 401) throw error.response;
    setNotify({
      title: "Oops!",
      message: error.response.data,
      type: "error",
      visible: true,
    });
  }

  setProgress(false);
};
